<template>
    <div class="segment-icon"
         @click="$emit('click')">
        <div v-if="displayType=='icon' || segment.svg">
            <div v-if="segment.image" :class="iconClassesFor('image')">
                <img :src="segment.image" :alt="segmentKey">
            </div>
            <div v-else-if="segment.svg" :class="iconClassesFor('svg-wrapper')">
                <component :is="segment.svg"
                           :class="iconClassesFor('svg')" />
            </div>
            <div v-else :class="iconClassesFor('icon-wrapper')">
                <i :class="iconClassesFor('icon')" />
            </div>
        </div>
        <div v-else
             class="segment-icon__image-segment"
             :style="backgroundImageUrl" />
    </div>
</template>

<script>

export default {

    props: {
        segmentKey: {
            type: String,
            required: true,
        },
    },

    computed: {

        backgroundImageUrl() {
            return `background: center / cover no-repeat url('${ this.segment.image }')`
        },

        displayType() {
            return !this.segment.image || this.segment.displayAs && this.segment.displayAs === 'icon'
                ? 'icon' : 'image'
        },

        segment() {
            return this.$scheme.segmentKeymap.find(seg => seg.key == this.segmentKey) || { icon: 'home' }
        },
    },

    methods: {

        iconClassesFor(type) {
            return this.segment.image
                ? `segment-icon__${ type } segment-icon__${ type }--${ this.segmentKey }`
                : `segment-icon__${ type } segment-icon__${ type }--${ this.segmentKey }${ (type == 'icon' ? ` fas fa-${ this.segment.icon }` : '') }`
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\my-home\_segment-icon.scss

$icon-size: 2rem;
$fa-icon-size: 1.6rem;
$upper-scaling-factor: 1.5;

.segment-icon {
    display: inline-block;
    height: calc(#{$icon-size} * 1.2);
    width: calc(#{$icon-size} * 1.2);

    @include bp-min-small {
        height: calc(#{$icon-size} * #{$upper-scaling-factor});
        width: calc(#{$icon-size} * #{$upper-scaling-factor});
    }

    @include elements('image' 'icon-wrapper' 'image-segment' 'text-wrapper' 'svg-wrapper') {
        background: transparent;
        height: calc(#{$icon-size} * 1.2);
        width: calc(#{$icon-size} * 1.2);

        @include bp-min-small {
            height: calc(#{$icon-size} * #{$upper-scaling-factor});
            width: calc(#{$icon-size} * #{$upper-scaling-factor});
        }
    }

    @include element('icon-wrapper') {
        text-align: center;
        font-size: calc(#{$fa-icon-size} * 1.2);

        @include bp-min-small {
            font-size: calc(#{$fa-icon-size} * #{$upper-scaling-factor});
        }
    }
}

</style>
